'use strict';

angular.module('licensure.services')
    .factory('LicenseCharges', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/licensecharges/', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecharges/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_charge) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecharges/';
                if (!isUndefined(license_charge.id)) {
                    method = 'PUT';
                    url += license_charge.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_charge: license_charge
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/licensecharges/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
    ;